var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"py-2 bg-dark text-white-50",attrs:{"id":"sticky-footer"}},[_c('div',{staticClass:"container text-center"},[_c('small',[_vm._v("Copyright © Your Website")])])])
}]

export { render, staticRenderFns }